export const getBaseUrl = (): string => {
	if (process.env.NODE_ENV === "development") {
		return "https://localhost:3000";
	}

	return process.env.NEXT_PUBLIC_SITE_URL?.replace(/\/$/, "") ?? "";
};
